import { BaseClient } from '../BaseClient';
import { InventoryCatalog, InventoryCatalogList } from '../compiled-protos/inventory';
import { InventoryServiceClient } from '../compiled-protos/inventory.client';

class InventoryCatalogClient extends BaseClient {
  self: InventoryServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new InventoryServiceClient(this.transport);
  }

  public async Create(req: InventoryCatalog) {
    let res = InventoryCatalog.create();
    try {
      res = await this.self.createInventoryCatalog(req, this.getMetaData()).response;
    } catch (err) {
      console.error('InventoryCatalogClient.Create error:', err);
      throw err;
    }
    return res;
  }

  public async Get(req: InventoryCatalog) {
    let res = InventoryCatalog.create();
    try {
      res = await this.self.getInventoryCatalog(req, this.getMetaData()).response;
    } catch (err) {
      console.error('InventoryCatalogClient.Get error:', err);
      throw err;
    }
    return res;
  }

  public async BatchGet(req: InventoryCatalog) {
    let res = InventoryCatalogList.create();
    try {
      res = await this.self.batchGetInventoryCatalog(req, this.getMetaData()).response;
    } catch (err) {
      console.error('InventoryCatalogClient.BatchGet error:', err);
      throw err;
    }
    return res;
  }

  public async Update(req: InventoryCatalog) {
    let res = InventoryCatalog.create();
    try {
      res = await this.self.updateInventoryCatalog(req, this.getMetaData()).response;
    } catch (err) {
      console.error('InventoryCatalogClient.Update error:', err);
      throw err;
    }
    return res;
  }

  public async Delete(req: InventoryCatalog) {
    try {
      await this.self.deleteInventoryCatalog(req, this.getMetaData()).response;
    } catch (err) {
      console.error('InventoryCatalogClient.Delete error:', err);
      throw err;
    }
  }
}

export { InventoryCatalog, InventoryCatalogList, InventoryCatalogClient };

